<template>
  <button v-if="show" @click="handleExport" class="export-csv">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="currentColor"
      class="bi bi-download"
      viewBox="0 0 16 16"
    >
      <path
        d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"
      />
      <path
        d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"
      />
    </svg>
    导出
  </button>
</template>
<script>
import { Message } from "element-ui";
import { searchList } from "@/api";

export default {
  computed: {
    show() {
      return this.$route.query.export === "true";
    },
  },
  methods: {
    async handleExport() {
      try {
        const res = await searchList(1000, 1, {});
        if (res.code !== 200) throw new Error("导出失败！");
        let data = "资源标识,题名,所在区,资源类型,建筑类型,地点,简介,来源\n";
        const replace = (content) => content?.replace(/"/g, '""') ?? "";
        data += res.data.list
          .map((item) => {
            return `${item.id},"${replace(item.titleChs)}","${replace(
              item.countyName
            )}","${item.typeMain}","${item.typeName}","${replace(
              item.address
            )}","${replace(item.description)}","${item.source}"`;
          })
          .join("\n");
        const blob = new Blob([data], { type: "text/plain" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.download = "export.csv";
        a.href = url;
        a.click();
        setTimeout(() => {
          URL.revokeObjectURL(url);
        });
      } catch (error) {
        console.log(error);
        Message.error("数据导出失败！");
      }
    },
  },
};
</script>
<style scoped lang="less">
.export-csv {
  display: flex;
  column-gap: 8px;
  align-items: center;
  background: #ffffff;
  height: 28px;
  padding: 0 10px;
  border-radius: 5px;
  color: #333333;
  font-family: HYXuanSong95W;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.08);
  svg {
    fill: #EB5757;
  }
}
</style>
